import actions from './coupon_actions'
import state from './coupon_state'
import getters from './coupon_getters'
import mutations from './coupon_mutations'
// import watchers from './coupon_watchers'

export default {
    name: 'coupon',
    getters,
    mutations,
    state,
    actions
    // watchers
}
